import { $virtualModelsLoader } from '../../common/$virtualModels'
import { coreAppUsersResolveFunc } from './coreAppUsersVirtualModel'

export const loadCoreAppUsers = async () => {
  // VirtualModel としてLoad
  $virtualModelsLoader.loadModel(await coreAppUsersResolveFunc())
}
